import React, { useEffect, useRef, useState } from 'react';
import bemCn from 'bem-cn';
import { monthNames } from '../../consts/months.consts';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import { ImageHelper } from '../../classes/image-helper.class';
import UserCircleImage from '../user-circle-image';
import SniffButton from '../sniff-button';
import SeoReview from '../seo-review';
import Rating from '../rating/index';
import './style.scss';

const b = bemCn('review-card');
const bseo = bemCn('review-card-seo');

const isEllipsisActive = (el) => {
    const clone = el.cloneNode(true);
    const style = window.getComputedStyle(el);

    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.width = style.width; // keep same width
    clone.style.whiteSpace = style.whiteSpace;
    clone.style.lineHeight = style.lineHeight;

    // Remove the clamp to get natural height
    clone.style.webkitLineClamp = 'unset';
    clone.style.display = 'block';
    clone.style.overflow = 'visible';

    el.parentElement.appendChild(clone);

    const fullHeight = clone.getBoundingClientRect().height;
    const actualHeight = el.getBoundingClientRect().height;

    clone.remove();
    return fullHeight > actualHeight;
};

const ReviewCard = ({ review, useEffect: useEffectSSR, useState: useStateSSR, useRef: useRefSSR }) => {
    const useRefC = useRefSSR || useRef;
    const useEffectC = useEffectSSR || useEffect;
    const useStateC = useStateSSR || useState;

    const textRef = useRefC(null);
    const [needExpand, setNeedExpand] = useStateC(false);
    const revDate = review.submittedAt || review.createdAt;
    const dateObj = new Date(revDate);
    const utcMonth = dateObj.getUTCMonth();
    const utcYear = dateObj.getUTCFullYear();
    const date = `${monthNames[utcMonth]} ${utcYear}`;

    useEffectC(() => {
        if (textRef?.current) {
            setNeedExpand(isEllipsisActive(textRef.current));
        }
    }, [textRef]);

    const expandReview = () => {
        textRef.current.classList.toggle('text-expanded');
        setNeedExpand(false);
    };

    return (
        <div className={bseo()}>
            {review.stars > 0 && <SeoReview {...{ ...review, submittedAt: revDate, user: review.providedBy }} />}
            <div className="d-flex mb-2">
                <UserCircleImage
                    className={b('avatar')}
                    image={ImageHelper.getUrlFromOptions(review.providedBy.avatarAws, `full-fit-in/${IMG_RESIZES.x64}`)}
                    useState={useStateSSR}
                    SSR={!!useStateSSR}
                />
                <div>
                    <div className="snif-p snif-semibold text-dark mb-05">{review.providedBy.nameAndInitial}</div>
                    <div className="snif-s2 snif-regular text-medium">{date}</div>
                </div>
            </div>
            <Rating className="mb-2" value={review.stars} showNmb={false} />
            <div ref={textRef} className="review-text snif-s1 snif-regular text-dark">
                {review.comment}
            </div>
            {needExpand && (
                <SniffButton className="review-expand-btn" size="sm" color="secondary" onClick={expandReview}>
                    Read more
                </SniffButton>
            )}
        </div>
    );
};

export default ReviewCard;
